module.exports = __webpack_public_path__ + "46d6e81c7e51fb91a45337aa2cf65ed3.png";